/** True when viewing contents inside a shared parent folder. */
export function isInsideSharedFolder(fileManagerFilters) {
  return fileManagerFilters?.folder_shared === true;
}

/** Navigation flags when opening a folder. */
export function buildFolderNavigationSharedFlags({ entry, fileManagerFilters }) {
  const isSharedFolder = entry?.folder_shared === true;
  const isInsideShared = isInsideSharedFolder(fileManagerFilters);

  if (isSharedFolder) {
    return {
      folder_shared: true,
      ...(entry?.file_shared_contact_id?.length ? { shared_contact_list: entry.file_shared_contact_id } : {}),
    };
  }

  if (isInsideShared) {
    return {};
  }

  return { folder_shared: null, shared_contact_list: null };
}

/** Whether breadcrumb path up to index includes a shared folder. */
export function isSharedFolderInBreadcrumbPath(breadCrumbs, upToIndexInclusive) {
  if (!Array.isArray(breadCrumbs) || breadCrumbs.length === 0) return false;
  const endIndex = typeof upToIndexInclusive === 'number' ? upToIndexInclusive + 1 : breadCrumbs.length;
  return breadCrumbs.slice(0, endIndex).some((item) => item.folder_shared === true);
}
